import * as z from "zod";

/** `appEmbedEnabled` is null when the theme could not be read, so callers don't warn on an unknown state. */
export const getStorefrontLoaderStatus = {
  name: "getStorefrontLoaderStatus" as const,
  input: z.object({}),
  output: z.object({
    appEmbedEnabled: z.boolean().nullable(),
    scriptTagEnabled: z.boolean(),
    appEmbedEditorUrl: z.string().nullable(),
  }),
};
